import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const Warning = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.532 4.832 3.207 17.617a1.557 1.557 0 0 0 .026 1.593c.148.24.359.44.612.579.253.138.539.211.83.211h14.65c.291 0 .577-.073.83-.211.253-.139.464-.338.612-.579a1.56 1.56 0 0 0 .026-1.593L13.467 4.832a1.64 1.64 0 0 0-.615-.608 1.729 1.729 0 0 0-1.705 0 1.64 1.64 0 0 0-.615.608Zm.648 8.1-.239-3.11a20.006 20.006 0 0 1-.066-1.304c0-.36.108-.64.323-.842.217-.2.502-.301.854-.301.426 0 .712.13.855.386.145.258.218.63.218 1.114 0 .284-.018.575-.053.869l-.32 3.2c-.035.38-.11.673-.223.876-.114.204-.303.305-.567.305-.267 0-.455-.098-.558-.295-.105-.197-.18-.497-.224-.899Zm-.053 4.488c.251.22.544.33.88.33.322.004.633-.116.87-.334.248-.223.373-.53.373-.92 0-.345-.125-.64-.369-.882a1.217 1.217 0 0 0-.89-.364c-.348 0-.641.12-.882.364-.24.242-.359.537-.359.882 0 .396.125.704.377.924Z"
    />
  </Icon>
);

export default Warning;
